<template>
  <div class="card-additional-users-overlay">
    <div class="form-group">
      <label for="addUsers">Additional Users</label>
      <p class="small">Select users to have access to this card.</p>
      <ed-select placeholder="Select an Eved user..."
                 :options="filteredUsers"
                 track-by="Id"
                 v-model="additionalUsers"
                 :checkboxes="false"
                 @input="o => $emit('additionalUsers', additionalUsers = o)"
                 @open="onOpenUsers"
                 @scroll-bottom="() => loadUsers(false)"
                 server-search
                 @search="onUserSearch"
                 label="Name"
                 multiple />
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        additionalUsers: [],
        userLoader: {
          items: [],
          pageIndex: 0,
          hasMore: true,
          isLoading: false,
          searchTerm: ''
        }
      }
    },

    props: {
      divisionId: {
        type: [String, Number],
        required: true
      },
      cardId: String,
      cardHolderId: String
    },

    computed: {
      filteredUsers() {
        return this.userLoader.items
          .filter(u => u.Id !== this.cardHolderId)
          .sort((a, b) => a.Name.localeCompare(b.Name))
      }
    },

    methods: {
      onOpenUsers() {
        this.userLoader.searchTerm = ''
        this.loadUsers(true)
      },

      onUserSearch(term) {
        this.userLoader.searchTerm = term
        this.loadUsers(true)
      },

      async loadUsers(reset = false) {
        const loader = this.userLoader
        if (loader.isLoading) return

        if (reset) {
          loader.pageIndex = 0
          loader.items = []
          loader.hasMore = true
        }
        if (!loader.hasMore) return

        loader.isLoading = true
        try {
          const { data } = await this.api.get(
            this.api.$.divisionUsers,
            {
              params: {
                divisionId: this.divisionId,
                pageIndex: loader.pageIndex,
                pageSize: 50,
                searchTerm: loader.searchTerm
              }
            }
          )

          const { Items, HasMore } = data
          const mapped = Items.map(item => ({
            Id: item.VendorUserId,
            Name: item.FirstName + ' ' + item.LastName
          }))

          loader.items = reset ? mapped : loader.items.concat(mapped)
          loader.hasMore = HasMore
          loader.pageIndex += 1
        } catch (e) {
          console.error('loadUsers error', e)
        } finally {
          loader.isLoading = false
        }
      },

      async getAdditionalUsers() {
        if (!this.cardId) return
        try {
          const result = await this.api.get(
            `evedpaycards/${this.cardId}/additional-users`
          )
          if (result.data) {
            this.additionalUsers = result.data
            this.$emit('additionalUsers', this.additionalUsers)
          }
        } catch (err) {
          console.error('error fetching additional users', err)
        }
      }
    },

    async created() {
      this.loadUsers(true)
      await this.getAdditionalUsers()
    }
  }
</script>

<style lang="scss" scoped>
  .card-additional-users-overlay {
    background-color: white;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  }
</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-list/CardAdditionalUsers.vue